import React from "react";
import DisheSingle from "../components/DisheSingle.jsx";
import Header from "../components/Header";
import Layout from "../components/Layout.jsx";

export default function DisheDetails() {
  return (
    <Layout>
      <DisheSingle />
    </Layout>
  );
}
